export default __webpack_public_path__ + "static/media/big-event-3.178eafdf.png";